import { buildQuery, requestJson } from "./apiClient";

export function getPartnerDashboard() {
  return requestJson("/api/partner/dashboard");
}

export function listPartnerListings(params = {}) {
  return requestJson(`/api/partner/listings${buildQuery(params)}`);
}

export function getPartnerListing(listingId) {
  return requestJson(`/api/partner/listings/${listingId}`);
}

export function listPartnerSources() {
  return requestJson("/api/partner/sources");
}

export function getPartnerSource(sourceId) {
  return requestJson(`/api/partner/sources/${sourceId}`);
}
